module.exports = __webpack_public_path__ + "img/shpricilg.2747d365.png";